import React, { useState, useEffect } from 'react';
import { Container, Col, Modal, Button, Form, Row } from 'react-bootstrap';
import { CustomTextField } from '../../../shared/customTextField';
import { CustomButton } from '../../../shared/customButton';
import { CustomTextArea } from '../../../shared/customTextArea';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import styles from './submitTicket.module.scss';
import * as yup from 'yup';
import { Formik } from 'formik';
import { submitCustomerTicket } from '../../../../services/util/customerSupport';

const SubmitTicketModal = (props) => {

    let [isTicketCreationPending, setIsTicketCreationPending] = useState(false);

    //yup validations
    const schema = yup.object({
        issue_area: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60').required('Required'),
        issue_description: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(800, 'Character length should be less than 800').required('Required')
    });

    const onSubmit = async (values) => {
        setIsTicketCreationPending(true);
        let response = await submitCustomerTicket(values);
        if (response.success === true) {
            setIsTicketCreationPending(false);
            props.handleClose();
        } else {
            setIsTicketCreationPending(false);
        }
    }

    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Create a Support Ticket</h2>
                    </div>

                    <Col sm={12} className="mb-4">
                        <Container>
                            <p className={styles.stepSubtopicName}>
                                Issue Details
                            </p>
                        </Container>
                    </Col>
                    <Col sm={12}>
                        <Container>
                            <Formik
                                validationSchema={schema}
                                onSubmit={(values) => onSubmit(values)}
                                initialValues={{ issue_area: '', issue_description: '' }}>

                                {({
                                    values,
                                    errors,
                                    handleChange,
                                    handleSubmit,
                                    submitCount
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Row>

                                            <Col className={styles.pipelineConfigurationsCol}>
                                                <CustomTextField
                                                    label="Which aspect of HireTrace you are having trouble with ?"
                                                    classLabel="defaultLabel"
                                                    controlId="issue_area"
                                                    placeholder="Ex: Creating a Vacancy Pipeline"
                                                    type="text"
                                                    value={values.issue_area}
                                                    name="issue_area"
                                                    classType="defaultTextBox"
                                                    handleOnChange={handleChange}
                                                    maxlength={60}
                                                    errorMessage={errors.issue_area}
                                                    isInvalid={submitCount > 0 && !!errors.issue_area}
                                                />

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12} className={styles.pipelineConfigurationsCol}>

                                                <CustomTextArea
                                                    label="Explain your issue here"
                                                    name="issue_description"
                                                    values={values.issue_description}
                                                    errorMessage={errors.issue_description}
                                                    handleChange={handleChange}
                                                    isInvalid={submitCount > 0 && !!errors.issue_description}
                                                    remainingCount={(values.issue_description).length}
                                                    maxLength={800}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <CustomAlertBox
                                                    alertBodyText="After you submit the ticket, one of our agent will contact you via your account email 
                                                    ( jayasekaraachira@gmail.com)."
                                                    alertType="defaultAlert"
                                                />
                                            </Col>


                                        </Row>
                                        <Row className="mt-3 mb-5">

                                            <Col>
                                                <CustomButton
                                                    buttonType="submit"
                                                    label="Submit"
                                                    type="primaryBtn"
                                                    backicon={isTicketCreationPending ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                                    disabled={isTicketCreationPending ? true : false}
                                                />
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>




                        </Container>
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default SubmitTicketModal